<template>
  <div>
      <section class="generalContainer px-4 padding_top_sm">
        <div class="">
          <div class="row mt-0">
            <div class="col-lg-6 p-0">
              <div class="container">
                <div class="col-12">
                  <h2 class="font-bold padding_top_md px-4 margin_bottom_md">Discover crops</h2>
                </div>
              </div>

              <div class="cropspage__items d-flex justify-content-center">

                  <div class="dropdown">
                    <a href="#" data-toggle="dropdown" class="dropdown-toggle">
                      <div class="d-flex align-items-center bg__color_light px-3 py-2 mr-2 box_curved_small">
                          <h4 class="mr-3 font-md">Crop Type</h4>
                          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M0.410582 0.910826C0.736019 0.585389 1.26366 0.585389 1.58909 0.910826L5.99984 5.32157L10.4106 0.910826C10.736 0.585389 11.2637 0.585389 11.5891 0.910826C11.9145 1.23626 11.9145 1.7639 11.5891 2.08934L6.58909 7.08934C6.26366 7.41477 5.73602 7.41477 5.41058 7.08934L0.410582 2.08934C0.0851446 1.7639 0.0851446 1.23626 0.410582 0.910826Z"
                              fill="#353535" />
                          </svg>
                      </div>
                    </a>
                    <!-- <crop-types-modal :croptypes="crops" @filterCropType="filterCropType" /> -->
                    <crop-types-modal @cropTypeValues="cropTypeValues" />
                    
                  </div>

                  <div class="dropdown">
                    <a href="#" data-toggle="dropdown" class="dropdown-toggle">
                      <div class="d-flex align-items-center bg__color_light px-3 py-2 mr-2 box_curved_small">
                        <h4 class="mr-3 font-md">Farming Stage</h4>
                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0.410582 0.910826C0.736019 0.585389 1.26366 0.585389 1.58909 0.910826L5.99984 5.32157L10.4106 0.910826C10.736 0.585389 11.2637 0.585389 11.5891 0.910826C11.9145 1.23626 11.9145 1.7639 11.5891 2.08934L6.58909 7.08934C6.26366 7.41477 5.73602 7.41477 5.41058 7.08934L0.410582 2.08934C0.0851446 1.7639 0.0851446 1.23626 0.410582 0.910826Z"
                            fill="#353535" />
                        </svg>
                      </div>
                    </a>
                    <!-- <farming-stage-modal :stages="stages" @filterStage="filterStage" /> -->
                    <farming-stage-modal @stageValues="stageValues" />
                    
                  </div>

                  <div class="dropdown" id="myPriceDropDown">
                    <a href="#" data-toggle="" class="priceDropDown" aria-expanded="true">
                      <div class="d-flex align-items-center bg__color_light px-3 py-2 mr-2 box_curved_small">
                        <h4 class="mr-3 font-md">Price</h4>
                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0.410582 0.910826C0.736019 0.585389 1.26366 0.585389 1.58909 0.910826L5.99984 5.32157L10.4106 0.910826C10.736 0.585389 11.2637 0.585389 11.5891 0.910826C11.9145 1.23626 11.9145 1.7639 11.5891 2.08934L6.58909 7.08934C6.26366 7.41477 5.73602 7.41477 5.41058 7.08934L0.410582 2.08934C0.0851446 1.7639 0.0851446 1.23626 0.410582 0.910826Z"
                            fill="#353535" />
                        </svg>
                      </div>
                    </a>
                    <price-ton-modal :filtering="filtering" @priceValues="priceValues" />
                    <!-- <price-ton-modal @filterPrice="filterPrice" /> -->

                  </div>

                  <div class="dropdown">  
                    <a href="#" data-toggle="dropdown" class="dropdown-toggle">
                      <div class="d-flex align-items-center bg__color_light px-3 py-2 mr-2 box_curved_small">
                        <h4 class="mr-3 font-md">Location</h4>
                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0.410582 0.910826C0.736019 0.585389 1.26366 0.585389 1.58909 0.910826L5.99984 5.32157L10.4106 0.910826C10.736 0.585389 11.2637 0.585389 11.5891 0.910826C11.9145 1.23626 11.9145 1.7639 11.5891 2.08934L6.58909 7.08934C6.26366 7.41477 5.73602 7.41477 5.41058 7.08934L0.410582 2.08934C0.0851446 1.7639 0.0851446 1.23626 0.410582 0.910826Z"
                            fill="#353535" />
                        </svg>
                      </div>
                    </a>

                    <location-drop-down @locationValues="locationValues" />
                  </div>

              </div>

              <div class="container cropsSingleWrapper margin_top_lg margin_bottom_md">
                <div class="row">
                  
                  <div class="col-6 margin_bottom_md" v-for="(value, name, index) in groupedCrops" :key="index" >
                      <crop-row :crop="name" :arr="value" :offtakerCrops="offtakerCrops" @reGet="reGet" 
                      :gettingOfftakerCrops="gettingOfftakerCrops" />
                  </div>
                  <div class="col-12" v-if="isEmpty(groupedCrops) && !loading">
                    <empty-component>
                      No crops found
                    </empty-component>
                  </div>
                </div>
              </div>

              

            </div>
            <div class="col-lg-6 p-0">
              <div class="crop-map" id="crop-map" :style="{ height: clientHeight + 'px'}">


                <!-- <div class="d-flex justify-content-end margin_top_lg">
                  <button class="btn btn-support btn-sm py-2 font-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" class="mr-2" style="height: 16px; margin-bottom: -2px;" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M11 5C8.23858 5 6 7.23858 6 10V11V18H3C1.89543 18 1 17.1046 1 16V12C1 10.8954 1.89543 10 3 10L4 10C4 6.13401 7.13401 3 11 3H13C16.866 3 20 6.13401 20 10H21C22.1046 10 23 10.8954 23 12V16C23 17.1046 22.1046 18 21 18H19.874C19.4299 19.7252 17.8638 21 16 21H14.7324C14.3866 21.5978 13.7403 22 13 22C11.8954 22 11 21.1046 11 20C11 18.8954 11.8954 18 13 18C13.7403 18 14.3866 18.4022 14.7324 19H16C17.1046 19 18 18.1046 18 17V11V10C18 7.23858 15.7614 5 13 5H11ZM4 12H3L3 16H4V12ZM11 12.25C11 12.9404 10.4404 13.5 9.75 13.5C9.05964 13.5 8.5 12.9404 8.5 12.25C8.5 11.5596 9.05964 11 9.75 11C10.4404 11 11 11.5596 11 12.25ZM14.25 13.5C14.9404 13.5 15.5 12.9404 15.5 12.25C15.5 11.5596 14.9404 11 14.25 11C13.5596 11 13 11.5596 13 12.25C13 12.9404 13.5596 13.5 14.25 13.5ZM20 12H21V16H20V12Z"
                        fill="#F2950A" />
                    </svg>
                
                    Support</button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        
      </section>
  </div>
</template>

<script>
import CropTypesModal from '@/components/off-taker/discover/CropTypesModal';
import PriceTonModal from '@/components/off-taker/discover/PriceTonModal';
import FarmingStageModal from '@/components/off-taker/discover/FarmingStageModal';
import LocationDropDown from '@/components/off-taker/discover/LocationDropDown';
import CropRow from '@/components/off-taker/discover/CropRow';
import EmptyComponent from '@/components/utils/EmptyComponent';
import moment from 'moment';
import { isEmpty } from '../../helpers';
export default {
    data() {
        return {
          isEmpty,
          moment,
          clientHeight: 600,
          locations: [],
          loading: false,
          filtering: false,
          gettingOfftakerCrops: false,
          crops: [],
          offtakerCrops: [],
          groupedCrops: '',
          filterTypes: {
            type: [],
            location: [],
            min_price: '',
            max_price: '',
            stage: []
          }
        }
    },
    methods: {
      cropTypeValues(values) {
        this.filterTypes.type = values;
        this.filterCrops();
      },
      locationValues(values) {
        this.filterTypes.location = values;
        this.filterCrops()
      },
      priceValues(arr) {
        this.filterTypes.min_price = arr[0]
        this.filterTypes.max_price = arr[1]
        this.filterCrops()
      },
      stageValues(values) {
        this.filterTypes.stage = values;
        this.filterCrops();
      },
      filterCrops() {
          let url = ''
          const keys = Object.keys(this.filterTypes)
          keys.filter((item) => {
            const values = this.filterTypes[item].toString()
            if(values.length !== 0) {
              const string = `${item}=${values}`;
              url += `${string}&`
            }
          })
          if(url.endsWith('&')) {
              url = url.slice(0, -1)
            }
          this.filtering = true;
          this.$http.get(`farm_crops?${url}`)
          .then((response) => {
              this.crops = response.data.items
              this.crops.map(item => {
                item.currentStage = this.getCurrentStage(item);
                return item;
              });
              this.groupCrops(false) 
          })
          .catch((error) => {
              this.$toastr.error(error)
          })
          .finally(() => {
              this.filtering = false
          })
      },
      getAllCrops() {
        this.loading = true;
        this.$http.get('farm_crops')
        .then((response) => {
          console.log(response.data)
          this.crops = response.data.items   
          this.crops.map(item => {
            item.currentStage = this.getCurrentStage(item);
            return item;
          });
          this.groupCrops(true)
        })
        .catch((error) => {
          this.$toastr.error(error)
        })
        .finally(() => {
          this.loading = false
        })
      },
      groupCrops(init) {
        const obj = {}
        this.crops.filter(item => {
          if(obj[item.name]) {
            const values = Object.values(obj[item.name])
            values.push(item)
            return obj[item.name] = values
          } else {
            return obj[item.name] = [item]
          }
        })
        this.groupedCrops = obj
        if(init) {
          this.cropsLocations()
          this.initMap()
        }
      },

      initMap() {
        console.log({ lat: this.getAvLat(), lng: this.getAvtLng() });
        const map = new google.maps.Map(document.getElementById("crop-map"), {
            center: { lat: this.getAvLat(), lng: this.getAvtLng() },
            zoom: 6
        });

        const image = `${this.$baseImageUrl}/farmTag.svg`;
        const infoWindow = new google.maps.InfoWindow({ maxWidth: 280});
        
        this.locations.forEach((location, i) => {
            var marker = new google.maps.Marker({
            position: { lat: location.lat, lng: location.lng },
            map: map,
            icon: image,
            // shape: shape,
            // title: beach[0],
            zIndex: location.zIndex
          });
          
          marker.addListener('click', function() {
            infoWindow.setContent(location.description);
            infoWindow.open(map, marker);
          });
        });
      },
      getAvLat() {
        if (this.locations.length === 0) {
          return 6.45407;
        }
        let total = 0;
        this.locations.forEach(item => {
          total += item.lat;
        });
        return total / this.locations.length;
      },
      getAvtLng() {
        if (this.locations.length === 0) {
          return 3.39467;
        }
        let total = 0;
        this.locations.forEach(item => {
          total += item.lng;
        });
        return total / this.locations.length;
      },
      cropsLocations() {
        this.crops.filter((item, index) => {
          const info = `
            <div class="">
                <div class="crop-map__container ">
                    
                    <div class="crop-map__container__img">
                        <img src="${item.images && item.images[0] && item.images[0].url ? item.images[0].url : ''}" />
                        <div class="crop-map__container__img__caption">
                        <h4><i class="naira"></i> ${(item.kg_price / 0.001).toLocaleString() } <small class="smallFont">per ton</small></h4>
                        </div>
                    </div>
                
                    <div class="crop-map__container__content">
                        <div class="row margin_bottom_md">
                            <div class="col-6">
                                <h5 class="font-sm font-bold">${item.name}</h5>
                            </div>
                            <div class="col-6">
                                <p class="smallFont">${(item.kg_yield / 1000).toLocaleString()} ton(s)</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <p class="smallFont font-xs">Farming stage</p>
                                <h4 class="font-bold font-sm">${item.currentStage.name}</h4>
                            </div>
                            <div class="col-6">
                                <a href="http://localhost:8080/offtaker/crop/${item.id}" 
                                class="btn btn-sm btn-secondary-outline px-2 py-2">View Details</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          `;
          const { farm } = item;
          if (farm.longitude !== null && farm.latitude !== null) {
            this.locations.push({
              lat: farm.latitude,
              lng: farm.longitude,
              description: info,
              zIndex: index + 20
            });
          }
        });
      },
      getCurrentStage(crop) {
          const totalStages = crop.stages.length;
          let totalWeeks = 0;
          let currentStage = null;
          crop.stages.forEach((stage, i) => {
              let startDate = this.moment(crop.date_planted).add(totalWeeks, "weeks").unix();
              totalWeeks += stage.no_of_weeks;
              let endDate = this.moment(crop.date_planted).add(totalWeeks, "weeks").unix();
              let currentTime = this.moment().unix();
              if((currentTime > startDate && currentTime < endDate ) || (!currentStage && i === totalStages - 1) ) {
                  currentStage = stage;
              }
          });
          return currentStage;
      },
      getOfftakerCrops() {
        this.gettingOfftakerCrops = true;
        this.$http.get('off_takers/crops')
        .then((response) => {
          console.log('offtaker crops', response.data)
          this.offtakerCrops = response.data.items
        })
        .catch((error) => {
          this.$toastr.error(error)
        })
        .finally(() => {
          this.gettingOfftakerCrops = false;
        })
      },
      reGet() {
        this.getOfftakerCrops()
      }
    },
    components: {
      CropRow,
      LocationDropDown,
      CropTypesModal,
      FarmingStageModal,
      PriceTonModal,
      EmptyComponent
    },
    created() {
      this.getAllCrops()
      this.getOfftakerCrops()
    }
}
</script>

<style>

</style>